function ProductsField() {
    $('input#search-products-field').keypress(function (event) {
        let item = $(this)
        if (event.keyCode === 13) {
            const url = new URL(window.location.href)
            url.searchParams.set('search', item.val())
            location.href = url.search
        }
    })
}

function SubsectionMenu() {

    if (window.screen.width >= 640) {
        $(window).scroll(function () {
            var aTop = $('.subsection-menu').height()
            //console.log($(this).scrollTop());
            if ($(this).scrollTop() >= 676) {
                $('.subsection-menu').css({
                    position: 'fixed',
                    top: '80px',
                    width: '100%',
                    'z-index': '12',
                })
            } else {
                $('.subsection-menu').css({
                    position: 'relative',
                    top: 'unset',
                    width: '100%',
                    'z-index': '12',
                })
            }
        })
    }

}

function LoginModal() {

    const { openLoginModal } = window
    if (openLoginModal) {
        const modalRegister = $('#modal_register')
        if (modalRegister) $(modalRegister).foundation('open')

        $(modalRegister).on('click', '*[data-close]', (event) => {
            event.preventDefault()
            $(modalRegister).foundation('close')
        })
    }
}

function PasswordToggler() {

    //data-passwordField
    const passwordToggler = $('*[data-password-toggler]')
    if (passwordToggler.length) {
        passwordToggler.each((index, el) => {
            let hash = $(el).data('password-toggler')
            $(el).on('change', (event) => {
                if ($(event.target).is(':checked')) {
                    $(hash).attr('type', 'text')
                } else {
                    $(hash).attr('type', 'password')
                }
            })
        })
    }
}

function PreventFormSubmit() {
    $(
        '*[data-open], *[data-toggle], *[data-close], *[data-editable-overlay], *[data-ajax-action]'
    ).on('click', (event) => event.preventDefault())
}

function FireClickOnHash() {
    // A bare '#' (an href="#" link clicked before the JS was ready) names no target:
    // matching it would click the first href="#" on the page.
    if (window.location.hash.length > 1) {
        let target = $(`*[href="${window.location.hash}"]`)[0]
        $(target).trigger('click')
    }
}
function CommonListeners() {
    FireClickOnHash();
    PreventFormSubmit();
    PasswordToggler();
    LoginModal();
    SubsectionMenu();
    ProductsField();
}

export { CommonListeners }